import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";

    // Command log Api services
    export class ModelLockApi{

        unlockAllModels = (): Promise<IBasicCommandResponse> => {

            return FetchWrapper.sendCommandAndHandle("/api/1.0/modellocks/unlockall", {method : "post"});
        }

        lockAllModels(): Promise<IBasicCommandResponse> {

            return FetchWrapper.sendCommandAndHandle("/api/1.0/modellocks/lockall", { method: "post" });
        }
    }



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.model-lock-services.ts